(() => {
  if (customElements.get('leslis-prien-stock')) return;
  class PrienStock extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.unsubscribe?.();
      this.abort = new AbortController();
      this.form = document.getElementById(this.dataset.form);
      this.root = this.closest('product-info') || this.closest('.shopify-section');
      this.readMap();
      this.show(this.form?.querySelector('[name="id"]')?.value || this.dataset.variant);
      document.addEventListener('variant:change', event => {
        if (event.target !== this.form && !this.root?.contains(event.target)) return;
        const id = event.detail?.variant?.id;
        if (id) this.show(id);
      }, { capture: true, signal: this.abort.signal });
      this.form?.addEventListener('change', () => {
        this.show(this.form.querySelector('[name="id"]')?.value);
      }, { signal: this.abort.signal });
      if (window.theme?.pubsub) {
        this.unsubscribe = window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.productId) !== this.dataset.product || String(data.sectionId) !== this.dataset.section) return;
          const fresh = data.parsedHTML?.querySelector(`leslis-prien-stock[data-form="${this.dataset.form}"] [data-stock-map]`);
          if (fresh) this.readMap(fresh.textContent);
          this.show(data.variant?.id);
        });
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.unsubscribe?.(); }
    readMap(text) {
      try { this.map = JSON.parse(text ?? this.querySelector('[data-stock-map]')?.textContent ?? '{}'); }
      catch { this.map = {}; }
    }
    show(id) {
      if (!id) return;
      const ready = this.map[String(id)] === true;
      this.dataset.variant = String(id);
      this.querySelector('[data-ready]').hidden = !ready;
      this.querySelector('[data-made]').hidden = ready;
    }
  }
  customElements.define('leslis-prien-stock', PrienStock);
})();
